import { mapState } from 'vuex'
import filter from 'js/filter'
import { getTicketList, paypalAddOrder } from '@/service/vbef'
import { editXuserChannelByLocalShareChannelId } from 'js/shareChannel'
import {
  Alogin
} from '@/service/app'
import CardPay from '@/components/common/cardPay.vue'
const MOBILE_REGEX = /^1[3-9]\d{9}$/
const signUpMixins = {
  components: { CardPay },
  data() {
    const _this = this
    return {
      filter,
      ticketList: [],
      concurrentList: {
        'zh': [
          `主论坛：全球市场，中国力量`,
          `分论坛1：基因治疗带来CNS疾病治疗的变革`,
          `分论坛2：基因治疗在罕见病领域的前沿创新`,
          `分论坛3：基因治疗引领未来眼科&耳科治疗的格局重塑`,
          `分论坛4：免疫细胞治疗在肿瘤疾病中的突破性进展`,
          `分论坛5：免疫细胞治疗在自身免疫疾病中的突破性进展`,
          `分论坛6：下一代细胞疗法浪潮——In Vivo Car-t`,
          `分论坛7：成体干细胞与外泌体，从0到1`,
          `分论坛8：星辰大海，扬帆起航，iPSC衍生细胞药物`,
          `分论坛9：领航下一代小核酸药物，挖掘更多未竟医疗需求的治疗蓝海`,
          `分论坛10：全球先进疗法的探索： 溶瘤病毒、肿瘤疫苗在肿瘤治疗的新突破`,
          `分论坛11：全球先进疗法的探索：基因编辑从体外到体内的应用探索`,
          `分论坛12：各国CGT产品质量控制与检测的最新要求与最新技术`,
          `分论坛13：如何搭建符合CGT产品市场化特征的商业化生产体系`,
          `分论坛14：生物医学新技术的CMC与GMP科学考量`,
          `分论坛16：AI+药物研发最新进展与应用`,
          `分论坛17：基因与核酸治疗新型递送方式改善安全性及可及性`,
          `分论坛15：CGT中国资产的核心价值探讨`,
          `大会活动：项目路演`,
          `分论坛18：全球CGT在心血管&代谢领域的临床应用与突破`,
          `分论坛19：全球CGT在CNS&肿瘤领域的临床应用与突破`,
          `分论坛 20：全球CGT在抗衰和长寿领域的临床应用与突破`,
          `分论坛 21：聚势共生，全球CGT联盟网络的协同进化`,
          `分论坛 22：中国IIT成为全球标准的新支点`,
          `分论坛 23：东南亚细胞与基因治疗的国际创新与协同`,
          `大会活动：中国 IIT 资源对接会`,
          `大会活动：CGT海外BD资源对接会`,
          `先进治疗药品与临床新技术政策应用及解读（闭门会）`,
          `颁奖盛宴： “Rising Star”颁奖典礼暨晚餐交流会`,
          `大会活动：CSGCT欢迎晚宴`,
          `大会活动：CSGCT鸡尾酒晚会`,
          `大会活动：中国三甲医院生物医学新技术深度考察团`,
        ],
        'en': [
          `Global Market, Chinese Innovation`,
          `Session 1: Revolutionizing CNS Disease Treatments through Gene Therapy`,
          `Session 2: Frontier Innovations in Gene Therapy for Rare Diseases`,
          `Session 3: Gene Therapy for Ophthalmic and Otic Diseases`,
          `Session 4: Breakthrough Progress of Immune Cell Therapy in Oncology`,
          `Session 5: Breakthrough Progress of Immune Cell Therapy in Autoimmune Diseases`,
          `Session 6: The Next Wave of Cell Therapy: In Vivo CAR-T`,
          `Session 7: Adult Stem Cells and Exosomes: From 0 to 1`,
          `Session 8: The Advancement and Application of iPSC-Derived Cell Therapeutics`,
          `Session 9: Next-Generation Oligonucleotide Drugs: Addressing Unmet Medical Needs`,
          `Session 10: New Breakthroughs in Oncolytic Viruses and mRNA Cancer Vaccines`,
          `Session 11: Gene Editing Evolution: From Ex Vivo to In Vivo Applications`,
          `Session 12: Global CGT Quality Control: Latest Requirements & Technologies`,
          `Session 13: Building Commercial Manufacturing Systems for CGT Markets`,
          `Session 14: CMC & GMP Scientific Considerations for New Biomedical Technologies`,
          `Session 16: Latest Advancements and Applications of AI in Drug R&D`,
          `Session 17: Improving Safety & Accessibility via Novel Delivery Systems`,
          `Session 15: Exploring the Core Value of Chinese CGT Assets`,
          `Event: Chinese CGT Asset Showcase`,
          `Session 18: Global CGT in Cardiovascular & Metabolic Fields`,
          `Session 19: Global CGT in CNS & Oncology`,
          `Session 20: Global CGT in Anti-Aging and Longevity`,
          `Session 21: Synergistic Evolution of Global CGT Alliance Networks`,
          `Session 22: China IIT: A New Pillar for Global Standards`,
          `Session 23: Regional Innovation & Synergy in Southeast Asia`,
          `Event: China IIT Resource Matchmaking`,
          `Event: Overseas BD Networking`,
          `Closed-door Session: Policy Interpretation for Advanced Therapy Medicinal Products (ATMPs) and Clinical Innovative Technologies`,
          `Awards Gala: "Rising Star" Award Ceremony & Networking Dinner`,
          `Event: CSGCT Welcome Banquet`,
          `Event: CSGCT Cocktail Reception`,
          `Event: China Top Tertiary Hospitals IIT Policy VIP Delegation`,
        ]
      },
      companyprofileother: false,
      companyProfileList: [
        filter.dealLanguage('大型药企', 'Big Pharma'),
        filter.dealLanguage('CGT 创新药企', 'CGT Innovative Pharmaceutical Company '),
        filter.dealLanguage('投资机构（人民币）', 'Investment Agency (RMB Fund)'),
        filter.dealLanguage('投资机构（美元）', 'Investment Agency (USD Fund)'),
        filter.dealLanguage('临床前CRO企业 ', 'Pre-clinical CRO'),
        filter.dealLanguage('临床CRO企业 ', 'Clinical CRO '),
        filter.dealLanguage('CMO/CDMO企业', 'CMO/CDMO'),
        filter.dealLanguage(
          '供应链产品企业（原材料、试剂耗材、仪器设备等）',
          'Supply-Chain Solutions Provider(APIs、Reagent & Consumable Materials、Instrument & Equipment,etc.)'
        ),
        filter.dealLanguage('第三方检测服务企业', 'Testing Service Provider'),
        filter.dealLanguage('细胞存储企业', 'Cell Storage Services'),
        filter.dealLanguage(
          '国际业务服务企业（金融机构、律所等）',
          'Global Business Services(Financial Institution, Law Firm, etc.)'
        ),
        filter.dealLanguage('科研院所/高校', 'Academic & Research Institution/University'),
        filter.dealLanguage('医院/临床机构', 'Hospital/clinical institution'),
        filter.dealLanguage('监管机构/行业协会', 'Regulators/Industry Association'),
        filter.dealLanguage(
          '产业园区/孵化器/加速器等 ',
          'Industrial Park/Incubator/Accelerator, etc.'
        ),
        filter.dealLanguage('患者组织 ', 'Patient Group'),
        filter.dealLanguage('其他，请填写 ', 'Others, please specify'),
      ],
      currentAddressDto: [],
      addressDtoList: [],
      addressDtos: [],
      ruleValidate2: {
        name: [
          {
            required: true,
            message: filter.dealLanguage('请填写姓名', 'Please fill in your name'),
            trigger: 'blur',
          },
        ],
        compName: [
          {
            required: true,
            message: filter.dealLanguage('请搜索并选择公司', 'Please search and select a company'),
            trigger: 'change',
          },
        ],
        department: [
          {
            required: true,
            message: filter.dealLanguage('请填写部门', 'Please fill in the department'),
            trigger: 'blur',
          },
        ],
        title: [
          {
            required: true,
            message: filter.dealLanguage('请填写职位', 'Please fill in the position'),
            trigger: 'blur',
          },
        ],
        addressId: [
          {
            required: true,
            message: filter.dealLanguage('请选择', 'Please select'),
            trigger: 'change',
          },
        ],
        companyProfile: [
          {
            required: true,
            message: filter.dealLanguage('请选择公司性质', 'Please select'),
            trigger: 'change',
          },
        ],
        companyprofileother: [
          {
            required: true,
            message: filter.dealLanguage('请填写具体性质', 'Please fill in the specific nature'),
            trigger: 'blur',
          },
        ],
        concurrent2: [
          {
            required: true,
            type: 'array',
            message: filter.dealLanguage('请选择会议或活动', 'Please select a meeting or event'),
            trigger: 'change',
          },
        ],
        need2: [
          {
            required: true,
            max: 3,
            min: 3,
            type: 'array',
            message: filter.dealLanguage(
              '请选出最重要的3项需求',
              'Please select the top 3 requirements'
            ),
            trigger: 'change',
          },
        ],
        service2: [
          {
            required: true,
            message: filter.dealLanguage('请选择', 'Please select'),
            trigger: 'change',
          },
        ],
        activityTicketName: [
          {
            required: true,
            message: filter.dealLanguage('请选择', 'Please select'),
            trigger: 'change',
          },
        ],
        activityTicketNameEn: [
          {
            required: true,
            message: filter.dealLanguage('请选择', 'Please select'),
            trigger: 'change',
          },
        ],
        verifyCode: [
          {
            required: true,
            message: filter.dealLanguage(
              '请输入验证码',
              'Please enter the verification code'
            ),
            trigger: 'blur',
          },
          {
            trigger: 'blur',
            validator: this.validateCode
          },
        ],
        email: [
          {
            required: true,
            message: filter.dealLanguage('请输入您的邮箱', 'Please enter your E-mail'),
            trigger: 'blur',
          },
          {
            type: 'email',
            message: filter.dealLanguage('邮箱格式不正确', 'The E-mail format is incorrect'),
            trigger: 'blur',
          },
        ],
        mobile: [
          {
            required: true,
            message: filter.dealLanguage('请输入您的手机号', 'Please enter your mobile number'),
            trigger: 'blur',
          },
          {
            type: 'number',
            message: filter.dealLanguage(
              '手机号格式不正确',
              'The phone number format is incorrect'
            ),
            trigger: 'blur',
            transform(value) {
              if (_this.currentForm.mobileAreaCode == '86')
                return MOBILE_REGEX.test(value) ? Number(value) : false
            },
          },
        ],
      },
      paymentWay: 1,
      isVerifyCode: false
    }
  },
  computed: {
    ...mapState({
      static_img_url: (state) => state.static_img_url,
      user_key: (state) => state.user_key,
      appMobileAreaCodeDtos: (state) => state.appMobileAreaCodeDtos,
      activityId: (state) => state.activityId,
      activityDetail: (state) => state.activityDetail,
      user: (state) => state.user,
      isWeixinBrowser: (state) => state.isWeixinBrowser,
      vbef_path: (state) => state.vbef_path,
      index2_path: (state) => state.index2_path,
      language: (state) => state.language,
      isMobile: (state) => state.isMobile,
      channelDiscountRate: (state) => state.channelDiscountRate,
    }),
  },
  methods: {
    ininUserInfo() {
      const user = this.$store.state.user
      this.currentForm.name = user.name || ''
      this.currentForm.compName = user.compName || ''
      this.entityKeyword = user.compName || ''
      this.currentForm.entityId = user.entityId || 0
      this.currentForm.department = user.department || ''
      this.currentForm.title = user.title || ''
      this.currentForm.companyNatureId = user.companyNatureId || null
      this.currentForm.companyNatureOtherTagName = user.companyNatureOtherTagName || ''
      this.currentForm.mobile = user.mobile || ''
      this.currentForm.mobileAreaCode = user.mobileAreaCode || ''
      this.currentForm.email = user.email.includes('@privaterelay.appleid.com') ? '' : (user.email || '')
      if (this.wxCode) this.genOpenidByWechatCode()
    },
    async getTicketList() {
      let res = await getTicketList({
        actId: this.activityId,
        payType: this.language == 'zh' ? 1 : 2,
      })
      if (res.code == 0) {
        this.$set(this.$data, 'ticketList', res.data)
        if (res.data.length) {
          this.currentTicket = res.data[0]
          this.currentForm.activityTicketId = res.data[0].id
        }
      }
    },
    handleChangeNT(value, isfirst = 0) {
      if (!isfirst) this.currentForm.companyNatureOtherTagName = ''
      if (!value || !this.companyNatureTags.length) {
        this.compNTother = ''
        return
      }
      let item = this.companyNatureTags.find((a) => a.id === value)
      if (
        item.name.indexOf('其他') > -1 ||
        item.name.indexOf('Other') > -1 ||
        item.name.indexOf('other') > -1
      ) {
        this.compNTother = item.name
      } else {
        this.compNTother = ''
      }
    },
    submitEn() {
      if (this.buttonLoading) return
      this.$refs['current-form'].validate(async (valid) => {
        if (valid) {
          this.buttonLoading = true
          const orderParams = this.setOrderParams()
          if (this.paymentWay == 1 && this.currentTicket.price) {
            const formParams = {
              email: this.currentForm.email,
            }
            this.$refs['card-pay'].handlePay(orderParams, formParams)
            return
          }
          let res = await paypalAddOrder(orderParams)
          this.buttonLoading = false
          if (res.code == 0) {
            if (res.data.activityTicketUserRelationId) {
              this.$router.push({
                name: 'ticketDetail',
                params: { id: res.data.activityTicketUserRelationId }
              })
            }
            if (res.data.paypalUrl) {
              window.location.href = res.data.paypalUrl
            }
          } else {
            if (this.isMobile) {
              this.$notify(res.enMsg || res.msg)
            } else {
              this.$Message.error(res.enMsg || res.msg)
            }
          }
        } else {
          if (this.isMobile) {
            this.$notify('Please complete the form and submit it')
          } else {
            this.$Message.error('Please complete the form and submit it')
          }

        }
      })
    },
    setOrderParams() {
      let { activityTicketId, ...params } = this.currentForm
      let ticketParamsStr = JSON.stringify(params)
      return {
        activityTicketId: activityTicketId,
        checkFormJson: ticketParamsStr,
        loginPlatform: this.isMobile ? 9 : 8,
        payType: 4,
      }
    },
    handleSelectPaymentOption(value) {
      this.paymentWay = value
    },
    updateLoading(loading) {
      this.buttonLoading = loading
    },
    async validateCode(rule, value, callback) {  // 2手机号 11 邮箱登录
      if (this.isVerifyCode) {
        callback()
        return
      }

      let params = {
        loginPlatform: this.isMobile ? 9 : 8,
        type: this.language == 'zh' ? 2 : 11,
        email: this.currentForm.email || '',
        mobileAreaCode: this.currentForm.mobileAreaCode || '',
        mobile: this.currentForm.mobile || '',
        code: this.currentForm.verifyCode,
      }
      let res = await Alogin(params)
      if (res.code == 0) {
        this.$store.commit('updateInterimUserKey', res.data.userKey)
        this.isVerifyCode = true
        if (this.wxCode) this.genOpenidByWechatCode()
        editXuserChannelByLocalShareChannelId(this.$store.state.activityId)
        callback()
      } else {
        this.$store.commit('updateInterimUserKey', null)
        this.isVerifyCode = false
        callback(new Error(filter.dealLanguage(
          res.msg,
          res.enMsg
        )));
      }
    },
    handleUpdateMobile() {
      this.$store.commit('updateInterimUserKey', null)
      this.isVerifyCode = false
      this.currentForm.mobile = ''
      this.currentForm.verifyCode = ''
      this.currentForm.email = ''
    }
  },
}
export { signUpMixins }
